import { Box, Button, Dialog } from '@betterment/samba-react';

import { ReturnDescriptionCard } from './ReturnDescriptionCard';

export const timeWeightedReturnDescription =
  'Measures how well your investments performed regardless of when you added or withdrew money. Best for evaluating performance and comparing with other investments.';
export const moneyWeightedReturnDescription =
  'Measures the actual return on your invested dollars, taking into account the timing and size of your deposits and withdrawals. Best for understanding the growth of your personal wealth.';

export const UnderstandingReturnsDialog: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <Dialog>
      <Dialog.Trigger asChild={true}>
        <Button
          variant="textPrimary"
          aria-label="Learn more about understanding returns"
          css={{ display: 'flex', alignItems: 'center', gap: 'space.50' }}
        >
          {children}
        </Button>
      </Dialog.Trigger>
      <Dialog.Content
        css={{
          display: 'grid',
          padding: 'space.600',
          width: '100%',
          maxWidth: 'container.xlarge',
          maxHeight: '80vh',
          overflow: 'auto',
          gap: 'space.300',
        }}
      >
        <Dialog.Title>Understanding your returns</Dialog.Title>
        <Dialog.Description>
          <Box css={{ display: 'grid', gap: 'space.300' }}>
            <ReturnDescriptionCard
              iconName="Trend"
              description={timeWeightedReturnDescription}
              header="Time-weighted return"
            />
            <ReturnDescriptionCard
              iconName="Bar"
              description={moneyWeightedReturnDescription}
              header="Money-weighted return"
            />
          </Box>
        </Dialog.Description>
      </Dialog.Content>
    </Dialog>
  );
};
